/**
 * livroRegistroBuilder (S5) — livro de registros acadêmico.
 *
 * @since S5 (fechamento admin)
 */
import type { $Fetch } from 'ofetch';

import { HttpLivroRegistroGateway } from '@/infrastructure/http/HttpLivroRegistroGateway';
import {
  ListLivrosRegistro, AbrirLivroRegistro, FecharLivroRegistro,
  ListLivroRegistroItens, AddLivroRegistroItem,
} from '@/application/usecase/LivroRegistroUseCaseImpl';

export function buildLivroRegistroSlice(httpClient: $Fetch) {
  const gateway = new HttpLivroRegistroGateway(httpClient);

  const useCases = {
    listLivrosRegistro: new ListLivrosRegistro(gateway),
    abrirLivroRegistro: new AbrirLivroRegistro(gateway),
    fecharLivroRegistro: new FecharLivroRegistro(gateway),
    listLivroRegistroItens: new ListLivroRegistroItens(gateway),
    addLivroRegistroItem: new AddLivroRegistroItem(gateway),
  };

  return { useCases };
}
